//webpack://ReactSimpleChatbot/lib/steps_components/options/OptionsStepContainer.jsx
import styled from 'styled-components';
const OptionsStepContainer = styled.div``;
export default OptionsStepContainer;
